import React, { Component } from 'react';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { SubsectionHeading } from 'web-ui-components/lib/typography/headings';
import InternetBankingActions from '../../actions/InternetBankingActions';
import StepHeader from '../../includes/StepHeader';
import PatternLibModalComponent from '../common/modals/PatternLibModalComponent';

export class PrivateBankingBenefits extends Component {
  constructor(props) {
    super(props);
    this.handleBackButton = this.handleBackButton.bind(this);
    this.state = {
      showModal: false,
    };
  }
  handleBackButton() {
    InternetBankingActions.navigateToWebTask('WEB-ACCOUNT-DETAILS');
  }
  continue(e) {
    e.preventDefault();
    this.setState({ showModal: false });
    window.open('https://uk.virginmoney.com/private/benefits-and-services/');
  }
  getModalHeading = () => {
    const { content } = this.props;
    return (
      <p>
        <strong>{content.modalHeading}</strong>
      </p>
    );
  };
  getModalBody = () => {
    const { content } = this.props;
    return (
      <div>
        <p>{content.HelpPopupContent1}</p>
        <p>{content.HelpPopupContent2}</p>
      </div>
    );
  };
  getModalFooter = () => {
    const { content } = this.props;
    return (
      <div className="button-group">
        <NavigationButton.Secondary
          labelText={content.cancelButtonText}
          onClick={() => this.setState({ showModal: false })}
        />
        <NavigationButton.Primary
          labelText={content.continueButtonText}
          onClick={(e) => this.continue(e)}
        />
      </div>
    );
  };

  render() {
    const { content } = this.props;
    const { showModal } = this.state;
    return (
      <div className="page bow manage-insurance-page">
        <div id="site-main" className="container" role="main" tabIndex="-1">
          <div className="row">
            <div className="col-md1-18">
              {
                <StepHeader
                  showheaderCrumbs
                  headerCrumbsMessage={content.back}
                  headerTitle={content.privateBankingPageHeader}
                  onClick={this.handleBackButton}
                />
              }
            </div>
          </div>
          <StandardBody>{content.privateBankingText1}</StandardBody>
          <StandardBody>{content.privateBankingText2}</StandardBody>
          <ul>
            <li>{content.bankingBenefitOption1}</li>
            <li>{content.bankingBenefitOption2}</li>
            <li>{content.bankingBenefitOption3}</li>
          </ul>
          <StandardBody>{content.privateBankingText3}</StandardBody>
          <ul>
            <li>{content.bankingBenefitOption4}</li>
            <li>{content.bankingBenefitOption5}</li>
          </ul>
          <StandardBody>
            {content.bankingBenefitMoreInfo}
            <a
              className="phone-no"
              onClick={() => this.setState({ showModal: true })}
            >
              {content.bankingBenefitHelpfulGuide}
            </a>
            {'.'}
          </StandardBody>
          <SubsectionHeading>{content.bankingBenefitMessage}</SubsectionHeading>
          <StandardBody>{content.bankingBenefitContactGuide}</StandardBody>
        </div>
        <PatternLibModalComponent
          show={showModal}
          onHide={() => this.setState({ showModal: false })}
          bsSize={'medium'}
          modalHeading={this.getModalHeading()}
          modalBody={this.getModalBody()}
          modalFooter={this.getModalFooter()}
          customClass={'c-modal'}
        />
      </div>
    );
  }
}
